import * as util from 'util';
import _ from 'lodash';
import {GeneralService} from '../../../../../services/generalService';
import {RouteService} from '../../../../../services/routeService';
import {DICTIONARY} from '../../../../../dictionary';
import {NotificationService} from '../../../../../services/notificationService';
import {Component, OnInit} from "@angular/core";
import {ClipboardService} from 'ngx-clipboard';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';


@Component({
	selector: 'email-relay-integration-component',
	templateUrl: './email-relay-integration.component.html',
})
export class EmailRelayIntegrationComponent implements OnInit {
    dic = DICTIONARY;
    verifiedDomainExist = false;
    corpname = this.gs.corpname;
    emailRelayHeader = 'x-trustifi-creds';
    planInfo: any;
    selectedServerEndpoint: { name: string; AzureAD: string; MSGraphAPI: string; };
	showJournalAddress: Boolean;
	userInfo: any;
    relayConnectedStatus: string;
    updateMtaInProcess: boolean;
    outboundRelayDomainErr: boolean;
    mtaToMove: any;
    mtaInEdit: any;
    updateIgnoreDomainInProcess: boolean;
    ignoreDomain: any;
	showEmailRelayUsername;
	showEmailRelayPassword;
	showEmailRelayPassword2;
	showEmailRelayKey;
	showEmailRelayKey2;
	actionInProcess;
	failedEmailDeliveryRecipient;
	failedDeliveryEmailsPopup;
	regenerateInProcessER: boolean;
	changeArchPopup: any
	selectedArchitecture;
	showAddErKeyPopup;

	sendingArchitecturesData = {
		[this.dic.CONSTANTS.sendingArchitecture.trustifi]: {
			name: 'Trustifi MTA',
			description: 'Emails will be sent from your mail server to Trustifi\'s MTA (all email protections will be applied here), from which it will be sent to your recipients.',
			icon: 'far fa-project-diagram',
		},
		[this.dic.CONSTANTS.sendingArchitecture.client]: {
			name: 'Your MTA',
			description: 'Emails will be sent from your mail server to Trustifi\'s MTA (all email protections will be applied here), and back into your MTA from which they will be sent to your recipients.',
			icon: 'far fa-code-branch',
		},
		[this.dic.CONSTANTS.sendingArchitecture.journal]: {
			name: 'Journal',
			description: 'Outbound mail flow will be configured using a journal rule. Trustifi will scan journaled copies of your sent emails for sensitive content.',
			icon: 'far fa-exchange-alt',
		}
	}

    constructor(public gs:GeneralService,
				private rs:RouteService,
				private ns:NotificationService,
				private clipboard: ClipboardService) {
    }

	ngOnInit() {

		this.gs.getUserInfo(false, (userInfo) => {
			this.userInfo = userInfo;
		});

		this.rs.getOutboundPlanSettings().then((planInfo) => {
            this.planInfo = planInfo;

			this.relayConnectedStatus = planInfo.outbound_relay?.is_connected ? DICTIONARY.CONSTANTS.relayStatus.active : DICTIONARY.CONSTANTS.relayStatus.inactive;

			this.selectedServerEndpoint = _.clone(DICTIONARY.CONSTANTS.exchangeServerEndpoints.Global);
			if (this.planInfo.exchange_server?.endpoint_name) {
				this.selectedServerEndpoint.name = this.planInfo.exchange_server.endpoint_name;
				this.selectedServerEndpoint.AzureAD = this.planInfo.exchange_server.azuread_endpoint;
				this.selectedServerEndpoint.MSGraphAPI = this.planInfo.exchange_server.msgraph_endpoint;
			}

			if (this.planInfo.domains?.length) {
				this.planInfo.domains.forEach((domainObj) => {
					if (domainObj.verified) {
						this.verifiedDomainExist = true;
					}
				});
			}

			if (this.planInfo.outbound_relay) {
				this.planInfo.outbound_relay.keyAndSecret = `${this.planInfo.outbound_relay.key}:${this.planInfo.outbound_relay.secret}`;
				if (this.planInfo.outbound_relay.secret2) {
					this.planInfo.outbound_relay.keyAndSecret2 = `${this.planInfo.outbound_relay.key}:${this.planInfo.outbound_relay.secret2}`;
				}
			}

			this.selectArchitecture(this.planInfo.outbound_relay.sending_architecture);
        }, (err) => {

		});
    };

	onDragStartMta(mta: any) {
		this.mtaToMove = mta;
	}

	onDropMta(event: CdkDragDrop<any[]>) {
		if (!this.mtaToMove) return;

		const prevIndex = this.planInfo.outbound_relay.mtas.findIndex(m => m === this.mtaToMove);
		const currIndex = event.currentIndex;

		// Update local array for UI
		moveItemInArray(this.planInfo.outbound_relay.mtas, prevIndex, currIndex);

		this.updateEmailRelayConfig(DICTIONARY.CONSTANTS.erSettingsActions.mta, 'move', currIndex);
	}

	updateFailedEmailDeliverySettings = (action) => {
		const tpData: any = {action};

		switch (action) {
			case this.dic.CONSTANTS.actions.update:
				tpData.data = {enabled: this.planInfo.failed_email_delivery_notifications.enabled};
				break;

			case 'outbound_use_sender_from':
				tpData.data = {enabled: this.planInfo.failed_email_delivery_notifications.outbound_use_sender_from};
				break;

			default:
				return;
		}

		this.actionInProcess = true;
		this.rs.updateMtaErrorsSettings(tpData).then(() => {
			this.ns.showInfoMessage(this.dic.MESSAGES.changedSuccessfully);

			this.actionInProcess = false;
		});
	}

	addFailedEmailDeliveryRecipient = () => {
		if (this.actionInProcess) return;

		if (!this.failedEmailDeliveryRecipient) {
			this.ns.showErrorMessage(util.format(this.dic.ERRORS.emptyField, 'Recipient'));
			return;
		}
		if (!this.gs.validateEmail(this.failedEmailDeliveryRecipient)) {
			this.ns.showWarnMessage(util.format(this.dic.ERRORS.EnterValidX, 'email address'));
			return;
		}
		if ((this.planInfo.failed_email_delivery_notifications.recipients || []).find(itm => itm === this.failedEmailDeliveryRecipient)) {
			this.ns.showErrorMessage(util.format(this.dic.ERRORS.itemAlreadyExist, this.failedEmailDeliveryRecipient));
			return;
		}

		this.actionInProcess = true;
		const tpData:any = {
			action: this.dic.CONSTANTS.actions.add,
			data: {
				recipient: this.failedEmailDeliveryRecipient
			}
		};

		this.rs.updateMtaErrorsSettings(tpData).then(() => {
			this.actionInProcess = false;
			this.planInfo.failed_email_delivery_notifications.recipients.push(this.failedEmailDeliveryRecipient);
			this.failedEmailDeliveryRecipient = '';

			this.ns.showInfoMessage(this.dic.MESSAGES.changedSuccessfully);
		}, (err) => {
			this.actionInProcess = false;
		});
	}

	deleteFailedEmailDeliveryRecipient = (address) => {
		if (this.actionInProcess) return;

		this.actionInProcess = true;
		const tpData:any = {
			action: this.dic.CONSTANTS.actions.delete,
			data: {
				recipient: address,
			}
		};

		this.rs.updateMtaErrorsSettings(tpData).then(() => {
			this.actionInProcess = false;
			_.remove<any>(this.planInfo.failed_email_delivery_notifications.recipients, (itm:any) => itm === address);

			this.ns.showInfoMessage(this.dic.MESSAGES.changedSuccessfully);
		}, (err) => {
			this.actionInProcess = false;
		});
	}

	openFailedDeliveryEmailsPopup = () => {
		this.failedDeliveryEmailsPopup = {
			mtaErrors: [],
			loading: true,
			show: true
		};

		this.getPlanMtaErrors();
	}

	getPlanMtaErrors = () => {
		this.failedDeliveryEmailsPopup.loading = true;

		this.rs.getPlanMtaErrors().then((response) => {
			this.failedDeliveryEmailsPopup.mtaErrors = (response || []).filter(itm => itm.direction === 'outbound');
			this.failedDeliveryEmailsPopup.loading = false;
		}, err => {
			this.failedDeliveryEmailsPopup.loading = false;
		});
	}

	searchFailedDeliveryEmail = (searchTerm, activeFilters) => {
		this.failedDeliveryEmailsPopup.mtaErrors.forEach(record => {
			// search
			if (!searchFailedDeliveryEmailExecute(record, searchTerm)) {
				record.hide = true;
				return;
			}

			// filter
			// no filters in this table

			record.hide = false;
		});

	};

	updateEmailRelayStatus() {
		let title = "", button = "", subTitle = "", body = [], type = DICTIONARY.CONSTANTS.popupWarning;

		if (this.planInfo.outbound_relay.sending_architecture === DICTIONARY.CONSTANTS.sendingArchitecture.client && (!this.planInfo.outbound_relay.mtas ||
			!this.planInfo.outbound_relay.mtas.length)) {
			this.planInfo.outbound_relay.enabled = !this.planInfo.outbound_relay.enabled;
			return this.ns.showWarnMessage(DICTIONARY.ERRORS.adminMtaMissing);
		}
		else if (this.planInfo.outbound_relay.sending_architecture === DICTIONARY.CONSTANTS.sendingArchitecture.trustifi && !this.verifiedDomainExist) {
			const message = (util.format(DICTIONARY.ERRORS.noDomainsToVerify,
				'<a target="_self" href="/' + DICTIONARY.CONSTANTS.appStates.adminOutbound + '/' + DICTIONARY.CONSTANTS.adminPages.outbound.sharedPlan + '/' + DICTIONARY.CONSTANTS.outboundPlanSettingsPageTabs.domains + '"><b><i>Domains</i></b></a>'));
			this.planInfo.outbound_relay.enabled = !this.planInfo.outbound_relay.enabled;
			return this.ns.showWarnMessage(message);
		}

		if (this.planInfo.outbound_relay.enabled) {
			button = "Enable";
			title = "Enable Email-Relay";
			subTitle = "You are about to enable Email Relay.";
			body = ["All users under Email-Server that configured this key may join your plan and send emails through the Email Relay."];
			type = DICTIONARY.CONSTANTS.popupInfo;
		}
		else {
			button = "Disable";
			title = "Disable Email-Relay";
			subTitle = "You are about to disable Email Relay!";
			body = [
				"Disabling the email relay will stop all outbound email traffic and protection through Trustifi",
				"<b>Important</b>: Before disabling the email relay, make sure you've stopped all outbound email traffic to Trustifi in your email server. Otherwise, you may experience delivery issues.",
				'Technical documentation for disconnecting the Trustifi outbound relay: <a href="https://docs.trustifi.com/docs/0365-outbound-relay-disconnecting" target="_blank">Office365</a> or <a href="https://docs.trustifi.com/docs/google-outbound-relay-disconnecting" target="_blank">Google Workspaces</a>',
			];
		}

		this.gs.showPopup({
			title: title,
			subTitle: subTitle,
			body: body,
			type: type,
			doneBtnText: button,
			doneCb: () => {
				const actionInfo = {
					action: DICTIONARY.CONSTANTS.erSettingsActions.emailRelay,
					type: 'status',
					enabled: this.planInfo.outbound_relay.enabled
				};
				this.rs.activateEmailRelayAndGenKey(actionInfo).then((response) => {
					this.ns.showInfoMessage(DICTIONARY.MESSAGES.changedSuccessfully);
					this.planInfo.outbound_relay = response || {};
					if (this.planInfo.outbound_relay) {
						this.planInfo.outbound_relay.keyAndSecret = `${this.planInfo.outbound_relay.key}:${this.planInfo.outbound_relay.secret}`;
						if (this.planInfo.outbound_relay.secret2) {
							this.planInfo.outbound_relay.keyAndSecret2 = `${this.planInfo.outbound_relay.key}:${this.planInfo.outbound_relay.secret2}`;
						}					}
					if (!this.planInfo.outbound_relay.enabled) {
						this.relayConnectedStatus = DICTIONARY.CONSTANTS.relayStatus.inactive;
					}
					this.planInfo.outbound_relay.sensitivity_threshold = this.planInfo.outbound_relay.sensitivity_threshold || 3;
				});
			},
			cancelCb: () => {
				this.planInfo.outbound_relay.enabled = !this.planInfo.outbound_relay.enabled;
			}
		});
	};

	deleteEmailRelayKey(keyNumber) {
		this.gs.showPopup({
			title: "Delete Email Relay Key",
			subTitle: "You are about to Delete your Email Relay key!",
			body: ["All users under Email-Server that configured this key will not be able to send emails through Email Relay."],
			type: DICTIONARY.CONSTANTS.popupWarning,
			doneBtnText: "Delete",
			doneCb: () => {
				const actionInfo = {
					action: DICTIONARY.CONSTANTS.erSettingsActions.emailRelay,
					type: 'keys',
					keyAction: 'delete',
					key: keyNumber // there will be 2 keys (option are key 1 or 2)
				};
				this.rs.activateEmailRelayAndGenKey(actionInfo).then((response) => {
					this.ns.showInfoMessage(DICTIONARY.MESSAGES.changedSuccessfully);
					this.planInfo.outbound_relay = response || {};
					if (this.planInfo.outbound_relay) {
						this.planInfo.outbound_relay.keyAndSecret = `${this.planInfo.outbound_relay.key}:${this.planInfo.outbound_relay.secret}`;
						if (this.planInfo.outbound_relay.secret2) {
							this.planInfo.outbound_relay.keyAndSecret2 = `${this.planInfo.outbound_relay.key}:${this.planInfo.outbound_relay.secret2}`;
						}					}

				}, (err) => {
				});
			}
		});
	};

	regenerateEmailRelayKey(keyNumber) {
		this.gs.showPopup({
			title: "Regenerate Email Relay Key",
			subTitle: "You are about to change your Email Relay key!",
			body: ["All users under Email-Server that configured this key will not be able to send emails through Email Relay."],
			type: DICTIONARY.CONSTANTS.popupWarning,
			doneBtnText: "Regenerate",
			doneCb: () => {
				const actionInfo = {
					action: DICTIONARY.CONSTANTS.erSettingsActions.emailRelay,
					type: 'keys',
					keyAction: 'regenerate',
					key: keyNumber // there will be 2 keys (option are key 1 or 2)
				};
				this.regenerateInProcessER = true;
				this.rs.activateEmailRelayAndGenKey(actionInfo).then((response) => {
					this.ns.showInfoMessage(DICTIONARY.MESSAGES.changedSuccessfully);
					this.planInfo.outbound_relay = response || {};
					if (this.planInfo.outbound_relay) {
						this.planInfo.outbound_relay.keyAndSecret = `${this.planInfo.outbound_relay.key}:${this.planInfo.outbound_relay.secret}`;
						if (this.planInfo.outbound_relay.secret2) {
							this.planInfo.outbound_relay.keyAndSecret2 = `${this.planInfo.outbound_relay.key}:${this.planInfo.outbound_relay.secret2}`;
						}					}

					this.regenerateInProcessER = false;
				}, (err) => {
					this.regenerateInProcessER = false;
				});
			}
		});
    };

	addEmailRelayKey() {
		this.showAddErKeyPopup = {
			show: true,
			short: false,
			doneCb: () => {
				if (this.showAddErKeyPopup.inProcess) {
					return;
				}

				this.showAddErKeyPopup.inProcess = true;
				const actionInfo = {
					action: DICTIONARY.CONSTANTS.erSettingsActions.emailRelay,
					type: 'keys',
					keyAction: 'add',
					short: this.showAddErKeyPopup.short
				};
				this.rs.activateEmailRelayAndGenKey(actionInfo).then((response) => {
					this.ns.showInfoMessage(DICTIONARY.MESSAGES.changedSuccessfully);
					this.planInfo.outbound_relay = response || {};
					if (this.planInfo.outbound_relay) {
						this.planInfo.outbound_relay.keyAndSecret = `${this.planInfo.outbound_relay.key}:${this.planInfo.outbound_relay.secret}`;
						if (this.planInfo.outbound_relay.secret2) {
							this.planInfo.outbound_relay.keyAndSecret2 = `${this.planInfo.outbound_relay.key}:${this.planInfo.outbound_relay.secret2}`;
						}
					}

					this.showAddErKeyPopup = null;
				}, (err) => {
					this.showAddErKeyPopup.inProcess = false;
				});
			}
		};	};


	updateSendWelcomeSettings(type) {
        const updateData = {
            action: DICTIONARY.CONSTANTS.erSettingsActions.welcomeEmail,
			type,
            value: this.planInfo.outbound_relay.welcome_email[type]
        };

		this.actionInProcess = true;
        this.rs.activateEmailRelayAndGenKey(updateData).then(() => {
			this.actionInProcess = false;
            this.ns.showInfoMessage(DICTIONARY.MESSAGES.changedSuccessfully);
        }, () => {
			this.actionInProcess = true;
		});
    };

	selectArchitecture = (architectureName) => {
		this.selectedArchitecture = this.sendingArchitecturesData[architectureName];
		this.selectedArchitecture.key = architectureName;
	}

    updateSendingArchitecture = (architectureName) => {
        if (this.planInfo.outbound_relay.sending_architecture === architectureName) {
			return;
		}

        let bodyDetails = [];

		switch (architectureName) {
			case DICTIONARY.CONSTANTS.sendingArchitecture.trustifi:
				bodyDetails.push(`Emails will now sent from your mail server to Trustifi's MTA (all email protections will be applied here), from which it will be sent to your recipients`,
					`To avoid issues with email delivery, make sure your mail-flow connectors and rules are created according to the instructions <b><a href="https://docs.trustifi.com/docs/configuration-using-trustifi-mta" target="_blank">here</a></b>`);
				break;

			case DICTIONARY.CONSTANTS.sendingArchitecture.journal:
				bodyDetails.push('Configure the Journal Rule settings in Exchange/Google to scan your journaled emails in Trustifi.',
					'With the journal architecture, functions related to modification of the email body are not available. These functions include applying footers/headers to emails, encryption, and tracking.');
				break;

			case DICTIONARY.CONSTANTS.sendingArchitecture.client:
				if (!this.planInfo.outbound_relay.mtas?.length) {
					this.changeArchPopup = {
						show: true,
						port: 25,
						domain: '',
						host: '',
						architectureName
					};
					return;
				}
				break;
		}

        this.gs.showPopup({
            title: 'Change Sending Architecture',
            subTitle: `Please note - you are about to change your Email Relay sending architecture`,
            body: bodyDetails,
            type: DICTIONARY.CONSTANTS.popupWarning,
            doneBtnText: 'Approve',
            doneCb: () => {
                const updateData = {
                    action: DICTIONARY.CONSTANTS.erSettingsActions.sendingArchitecture,
                    sendingArchitecture: architectureName
                };

                this.rs.activateEmailRelayAndGenKey(updateData).then((outboundRelay) => {
                    this.ngOnInit();
                    this.ns.showInfoMessage(DICTIONARY.MESSAGES.changedSuccessfully);
                });
            }
        });
    };

	updateSendingArchitectureExecute = () => {
		if (!this.changeArchPopup.host && !this.changeArchPopup.domain && !this.changeArchPopup.port) {
			this.ns.showErrorMessage('You must enter a valid domain, MTA, and port number');
			return;
		}
		const updateData = {
			action: DICTIONARY.CONSTANTS.erSettingsActions.sendingArchitecture,
			sendingArchitecture: this.changeArchPopup.architectureName,
			domain: this.changeArchPopup.domain,
			mta: this.changeArchPopup.host,
			port: this.changeArchPopup.port
		};

		this.rs.activateEmailRelayAndGenKey(updateData).then((outboundRelay) => {
			this.changeArchPopup = null;
			this.ns.showInfoMessage(DICTIONARY.MESSAGES.changedSuccessfully);

			this.planInfo.outbound_relay = outboundRelay;
			this.verifyMta(this.planInfo.outbound_relay.mtas[0]);
		});
	}

    updateEmailRelayConfig = (action, type = "", index = null) => {
        this.updateMtaInProcess = true;

        let updateData:any = {action: action};
        switch (action) {
            case DICTIONARY.CONSTANTS.erSettingsActions.mta:
				if (type === 'move') {
                    updateData._id = this.mtaToMove._id;
                    updateData.idx = index;
                }
                else if (type === 'edit') {
                    updateData._id = this.mtaInEdit._id;
                    updateData.host = this.mtaInEdit.host;
                    updateData.port = parseInt(this.mtaInEdit.port);
                    updateData.domain = this.mtaInEdit.domain;
                }
                else {
                    if (this.planInfo.outbound_relay.enabled && this.planInfo.outbound_relay.mtas.length === 1) {
                        this.updateMtaInProcess = false;
                        return this.ns.showWarnMessage(DICTIONARY.ERRORS.CannotRemoveMta);
                    }
                    updateData._id = this.planInfo.outbound_relay.mtas[index]._id;
                    updateData.domain = this.planInfo.outbound_relay.mtas[index].domain;
                }
                updateData.type = type;
                break;
        }

        this.rs.activateEmailRelayAndGenKey(updateData).then((response) => {
			this.updateMtaInProcess = false;

			switch (action) {
                case DICTIONARY.CONSTANTS.erSettingsActions.mta:
                    for (let i = 0; i < response.mtas.length; i++) {
                        if (this.planInfo.outbound_relay.mtas[i] && this.planInfo.outbound_relay.mtas[i].editMode) {
                            response.mtas[i].editMode = true;
                            this.mtaInEdit = response.mtas[i];
                        }
                    }
                    this.planInfo.outbound_relay.mtas = response.mtas;
					if (type === 'move') {
                        this.mtaToMove = null;
                    }
                    else if (type === 'edit') {
						this.verifyMta(this.mtaInEdit);
						this.mtaInEdit.editMode = false;
                        this.mtaInEdit = null;
                    }
                    this.ns.showInfoMessage(DICTIONARY.MESSAGES.changedSuccessfully);
                    break;
            }
        }, err => {
			this.updateMtaInProcess = false;
        });
    };

	addMta = () => {
		if (!this.gs.isValidDomain(this.planInfo.outbound_relay.domain)) {
			this.ns.showWarnMessage(util.format(DICTIONARY.ERRORS.invalidDomain, this.planInfo.outbound_relay.domain));
			this.outboundRelayDomainErr = true;
			this.updateMtaInProcess = false;
			return;
		}

		this.planInfo.outbound_relay.newPort = parseInt(this.planInfo.outbound_relay.newPort);
		if (this.planInfo.outbound_relay.mtas.length) {
			for (let i = 0; i < this.planInfo.outbound_relay.mtas.length; i++) {
				if (this.planInfo.outbound_relay.mtas[i].host === this.planInfo.outbound_relay.host &&
					this.planInfo.outbound_relay.mtas[i].domain === this.planInfo.outbound_relay.domain &&
					this.planInfo.outbound_relay.mtas[i].port === this.planInfo.outbound_relay.newPort) {
					this.ns.showWarnMessage(util.format(DICTIONARY.ERRORS.mtaAlreadyExist, this.planInfo.outbound_relay.host));
					this.updateMtaInProcess = false;
					return;
				}
			}
			const recordsCountForDomain = _.sumBy<any>(this.planInfo.outbound_relay.mtas, m => m.domain === this.planInfo.outbound_relay.domain ? 1:0);
			if (recordsCountForDomain >= 3) {
				this.ns.showWarnMessage(util.format(DICTIONARY.ERRORS.CannotAddMta, this.planInfo.outbound_relay.domain));
				this.updateMtaInProcess = false;
				return;
			}
		}

		const updateData = {
			action: DICTIONARY.CONSTANTS.erSettingsActions.mta,
			type: 'add',
			host: this.planInfo.outbound_relay.host,
			port: this.planInfo.outbound_relay.newPort,
			domain: this.planInfo.outbound_relay.domain
		};

		this.rs.activateEmailRelayAndGenKey(updateData).then((response) => {
			this.updateMtaInProcess = false;

			this.planInfo.outbound_relay.mtas = response.mtas;
			this.planInfo.outbound_relay.host = '';
			this.planInfo.outbound_relay.newPort = '';
			this.planInfo.outbound_relay.domain = '';
			this.verifyMta(this.planInfo.outbound_relay.mtas[this.planInfo.outbound_relay.mtas.length - 1]);
			this.ns.showInfoMessage(DICTIONARY.MESSAGES.changedSuccessfully);
		}, err => {
			this.updateMtaInProcess = false;
		});
	}

	resolveDomainHost = (objToUpdate, domain) => {
		if (!this.gs.isValidDomain(domain)) {
			this.ns.showWarnMessage(util.format(DICTIONARY.ERRORS.invalidDomain, domain));
			this.outboundRelayDomainErr = true;
			return;
		}

		this.updateMtaInProcess = true;

		const updateData = {
			action: DICTIONARY.CONSTANTS.erSettingsActions.domainMta,
			domain: domain
		};

		this.rs.activateEmailRelayAndGenKey(updateData).then((response) => {
			objToUpdate.host = response.exchange;
			this.updateMtaInProcess = false;
		}, err => {
			this.updateMtaInProcess = false;
		});
	}

    setMTAForEdit = (mta) => {
        this.planInfo.outbound_relay.mtas = _.map(this.planInfo.outbound_relay.mtas, mta => {
            mta.editMode = false;
            return mta;
        });
        mta.editMode = true;
        this.mtaInEdit = mta;
    };

    verifyMta = (mtaObj) => {
        if (this.updateMtaInProcess) {
            return;
        }

        this.updateMtaInProcess = true;
        const actionInfo = {
            action: DICTIONARY.CONSTANTS.inboundRelayActions.mta,
            type: 'verify',
            host: mtaObj.host,
            port: mtaObj.port,
        }

		mtaObj['loading'] = true;

        this.rs.activateEmailRelayAndGenKey(actionInfo).then((response) => {
			mtaObj['verified'] = response.meta && response.meta.type === 'info';

			mtaObj['loading'] = false;
            this.updateMtaInProcess = false;
        }, (err) => {
            this.updateMtaInProcess = false;
			mtaObj['loading'] = false;
            mtaObj['verified'] = false;
        });
    };

	copyStaticIPs(type) {
		let str = '';
		if (type === 'google') {
			str = `^Received[:].+(${this.planInfo.outbound_relay.static_ip_set_ips.map(ip => ip.replace(/\./g, '[.]')).join('|')})`
		}

		this.clipboard.copy(str);
		this.ns.showInfoMessage(util.format(DICTIONARY.MESSAGES.copyClipboard, 'IPs'));
	}

	copyItem(item, name) {
		this.clipboard.copy(item);
		this.ns.showInfoMessage(util.format(DICTIONARY.MESSAGES.copyClipboard, name));
	}

    updateIgnoreDomains = (type, removedDomainIndex = null) => {
        let domain;
        switch (type) {
            case 'add':
                if (!this.ignoreDomain)
                    return;
                if (!this.gs.isValidDomain(this.ignoreDomain) && !this.gs.validateEmail(this.ignoreDomain)) {
                    return this.ns.showErrorMessage(util.format(DICTIONARY.ERRORS.invalidDomainOrAddress, this.ignoreDomain));
                }
                if (this.planInfo.ignore_send_domains.includes(this.ignoreDomain)) {
                    return this.ns.showWarnMessage(util.format(DICTIONARY.ERRORS.domainAlreadyExist, this.ignoreDomain));
                }
                domain = this.ignoreDomain;
                break;
            case 'remove':
                if (!this.planInfo.ignore_send_domains[removedDomainIndex]) return;
                domain = this.planInfo.ignore_send_domains[removedDomainIndex];
                break;
        }
        const updateData = {
            type: type,
            action: DICTIONARY.CONSTANTS.erSettingsActions.ignoreSendDomains,
            domain: domain
        };
        this.updateIgnoreDomainInProcess = true;

        this.rs.activateEmailRelayAndGenKey(updateData).then(() => {
            switch (type) {
                case 'add':
                    this.planInfo.ignore_send_domains.push(this.ignoreDomain);
                    this.ignoreDomain = '';
                    break;
                case 'remove':
                    this.planInfo.ignore_send_domains.splice(removedDomainIndex, 1);
                    break;
            }
            this.updateIgnoreDomainInProcess = false;
            this.ns.showInfoMessage(DICTIONARY.MESSAGES.ignoreSendDomainsUpdated);
        });
    };
}

function searchFailedDeliveryEmailExecute(email, searchTerm){
	searchTerm = searchTerm.toLowerCase();
	return ((email.subject && email.subject.toLowerCase().indexOf(searchTerm) > -1) ||
		(email.from && email.from.toLowerCase().indexOf(searchTerm) > -1) ||
		(email.rcptTo && email.rcptTo.toLowerCase().indexOf(searchTerm) > -1) ||
		(email.message_id && email.message_id.toLowerCase().indexOf(searchTerm) > -1) ||
		(email.text && email.text.toLowerCase().indexOf(searchTerm) > -1));
}
